import React from 'react';
import PropTypes from 'prop-types';
import { fixTableCellValue } from 'site-modules/shared/utils/voiceover';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { AvailableOnOtherStyles } from 'site-modules/comparator/components/available-on-other-styles/available-on-other-styles';

import './feature-field.scss';

export const AVAILABLE_ON_OTHER_STYLES = 'available on other styles';

export function FeatureField({
  name,
  value,
  style = null,
  featureCategorySlug = '',
  featureNameSlug = '',
  addVehicle = undefined,
  buttonClass = null,
}) {
  const currentValue = value.toLowerCase() === AVAILABLE_ON_OTHER_STYLES && !addVehicle ? 'Not Available' : value;

  return (
    <div className="feature-field" data-test={`feature ${name}`}>
      {currentValue.toLowerCase() === AVAILABLE_ON_OTHER_STYLES ? (
        <AvailableOnOtherStyles
          name={name}
          style={style}
          featureCategorySlug={featureCategorySlug}
          featureNameSlug={featureNameSlug}
          addVehicle={addVehicle}
          className={buttonClass}
        />
      ) : (
        <ContentFragment classes="feature-field-value">{fixTableCellValue(currentValue)}</ContentFragment>
      )}
    </div>
  );
}

FeatureField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  addVehicle: PropTypes.func,
  featureCategorySlug: PropTypes.string,
  featureNameSlug: PropTypes.string,
  style: PropTypes.shape({
    name: PropTypes.string,
    styleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  buttonClass: PropTypes.string,
};
